import React from 'react';
import { getStatus } from '../../constants/statuses';
import './StatusBadge.css';

/**
 * StatusBadge — статус документа одним видом во всей системе (аудит U17).
 *
 *   <StatusBadge entity="shipment" status={sh.status} />
 *   <StatusBadge tone="warning">Ждёт КИЗ</StatusBadge>     — произвольная метка
 *
 *   entity  — ключ справочника constants/statuses.js (arrival, pickup, shipment,
 *             order, kiz, wb_fbs, ozon_fbs, pvz_return, truck, …)
 *   status  — код статуса из API
 *   label   — своя подпись поверх справочника (редко)
 *   tone    — свой тон ('neutral'|'info'|'success'|'warning'|'danger'|'accent')
 *   size    — 'sm' | 'md';  dot — точка перед подписью (по умолчанию да)
 */
export function StatusBadge({ entity, status, label, tone, size = 'md', dot = true, title, className = '', children }) {
  const st = entity ? getStatus(entity, status) : { label: status, tone: 'neutral' };
  const t = tone || st.tone || 'neutral';
  const text = children ?? label ?? st.label;
  return (
    <span className={`ui-status ui-status--${t} ui-status--${size} ${className}`} title={title}>
      {dot && <span className="ui-status__dot" aria-hidden="true" />}
      {text}
    </span>
  );
}
